module.exports = __webpack_public_path__ + "img/download.add5b484.svg";